import React from 'react';

const Footer = () => {
  return (
    <footer className=" bg-gray-900 text-white py-4 mt-12 mb-0">
      <div className="container mx-auto text-center">
        <p className="mb-2">This site offers a user-friendly interface to browse and sort movies based on top ratings and popularity.</p>
        <p>Created by Mayank Tomar. <a href="https://github.com/tomarmayankk" className="text-blue-500 underline">GitHub</a></p>
      </div>
    </footer>
  );
};

export default Footer;
